<app-header page='duplicate'>Duplicate Campaign Url</app-header>
<div class="container">
  <app-campaign-form mode="duplicate"></app-campaign-form>
</div>